export const START_ACTION = '@UserForm/START'
export const SUCCESS_ACTION = '@UserForm/SUCCESS'
export const ERROR_ACTION = '@UserForm/ERROR'
export const RESET_ACTION = '@UserForm/RESET'
